import { render } from "./ViewInvoiceModal.vue?vue&type=template&id=522d017c&scoped=true"
import script from "./ViewInvoiceModal.vue?vue&type=script&lang=js"
export * from "./ViewInvoiceModal.vue?vue&type=script&lang=js"

import "./ViewInvoiceModal.vue?vue&type=style&index=0&id=522d017c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522d017c"]])

export default __exports__